/// AXIOS ///
import axios from "axios";
import { AxiosError } from "axios";
/// REDUX ///
import { Dispatch } from "redux";
import { RootState } from "api/reducers";
/// ACTIONS ///
import { Action } from "api/action_types/shop_material";
import { Action as AuthAction } from "api/action_types/authentication";
/// ACTION TYPES ///
import { ActionType } from "api/action_types/shop_material";
import { ActionType as AuthActionType } from "api/action_types/authentication";
/// TYPES ///
import { IShopColor } from "api/types/shop_material";
/// URLS ///
import { shop_color_url } from "../../endpoint";
import { url_prefix } from "settings";

export const updateShopColor = (color: IShopColor, id: string | number) => {
  return async (dispatch: Dispatch<Action | AuthAction>, getState: () => RootState) => {

    const { user } = getState().authentication;

    dispatch({
      type: ActionType.SHOP_MATERIAL_LOADING
    });

    dispatch({
      type: ActionType.UPDATE_LOCAL_SHOP_COLOR,
      color
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Token ${user.token}`
      }
    }

    const url = `${url_prefix}${shop_color_url}/${id}/`;

    try {
      await axios.patch(url, color, config);

      dispatch({
        type: ActionType.UPDATE_SHOP_COLOR
      });
    }
    catch (err) {
      if (err instanceof AxiosError) {
        dispatch({
          type: ActionType.SHOP_MATERIAL_ERROR,
          error: err.message
        });
        if (err && err.response && err.response.status === 401) {
          dispatch({
            type: AuthActionType.AUTH_FAILED
          });
        }
      }
    }
  }
}
